<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <div v-if="conversations">

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >
        <b-row>
          <!-- Search -->
          <b-col
              cols="12"
              md="6"
              class="m-2"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                  v-model="search"
                  class="d-inline-block mr-1"
                  placeholder="جستجو..."
              />
            </div>
          </b-col>

          <b-col
              cols="12"
              md="2"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>نمایش</label>
            <v-select
                v-model="perPage"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
            />
            <label>تعداد</label>
          </b-col>

          <b-col
              cols="12"
              md="3"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>نمایش بر اساس وضعیت چت :</label>
            <v-select
                v-model="hasSeen"
                :options="hasSeenOptions"
                :reduce="val => val.value"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50 w-50"
            />
          </b-col>
        </b-row>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="conversations"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >

          <template #cell(userInfo)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                    size="45"
                    :src="baseUrl+data.item.userInfo.selfieFileData"
                    :variant="`success`"
                    :to="{ name: 'apps-chats-id', params: { id: data.item.userInfo.userId } }"
                />
              </template>
              <b-link
                  :to="{ name: 'apps-chats-id', params: { id: data.item.userInfo.userId } }"
                  class="font-weight-bold d-block text-nowrap"
              >
                {{ data.item.userInfo.name }} {{ data.item.userInfo.familyName }}
              </b-link>
              <small class="text-muted">@{{ data.item.userInfo.userId }}</small>
            </b-media>
          </template>

          <template #cell(edit)="data">

            <router-link :to="{ name: 'apps-chats-id', params: { id: data.item.onlineChatId } }" class="cursor-pointer d-flex flex-row w-25">
              <feather-icon icon="EditIcon" size="20"/>
            </router-link>

          </template>

          <template #cell(unreadCount)="data">

            <b-badge
                pill
                class="text-capitalize"
                :variant="`primary`"
            >
              {{data.item.unreadCount}}
            </b-badge>

          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCount"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon style="transform: rotate(180deg)"
                                icon="ChevronLeftIcon"
                                size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination,BOverlay
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { hubInstance } from '@/libs/chatHub';
import Helper from "@/libs/Helper";
export default {
  name: "Chats",
  title: 'چت - پنل ادمین نهایی شو',
  data(){
    return{
      conversations:null,
      baseUrl:Helper.baseUrl,
      totalCount:null,
      currentPage:1,
      perPage:10,
      perPageOptions:[10, 20, 30 , 40 , 50],
      overlay:false,
      hasSeenOptions:[
        {label:'همه',value:null},
        {label:'خوانده شده',value:true},
        {label:'خوانده نشده',value:false},
      ],
      search:'',
      hasSeen:null,
      myTableColumns : [
        { key: 'userInfo',label:'اطلاعات کاربر'},
        { key: 'unreadCount',label:'پیام های خوانده نشده'},
        { key: 'edit',label:'نمایش'},
      ],
    }
  },
  inject:['chatHub'],
  mounted() {
    if (!hubInstance.isConnected()) {
      this.chatHub.onMyConnected.push(function() {
        this.getConversations();
      }.bind(this));
    } else {
      if (hubInstance.isConnected()){
        this.getConversations();
      }
    }
    this.chatHub.on("YouHaveNewMessage", function (res) {
      this.getConversations();
    }.bind(this))
  },
  methods:{
    getConversations(){
      this.chatHub.on('getmyconversationsuccess', function (res) {
        this.overlay = true;
        this.conversations = res.data;
        this.totalCount = res.total;
        this.overlay = false;
      }.bind(this));
      this.chatHub.invoke("GetMyConversation", this.currentPage , this.perPage , this.search , this.hasSeen);
    },
  },
  async beforeDestroy() {
    await this.chatHub.off("getmyconversationsuccess");
  },
  watch:{
    search:function (nv,ov){
      this.getConversations()
    },
    currentPage:function (nv,ov){
      this.getConversations()
    },
    perPage:function (nv,ov){
      this.getConversations()
    },
    hasSeen:function (nv,ov){
      this.getConversations()
    },
  },
  components:{
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    BOverlay,
    vSelect
  },
}
</script>

<style scoped>

</style>